<template>
  <v-container v-if="webshopPayment" id="online-purchase-show">
    <MaterialCard
      color="primary"
      elevation="1"
      class="tour-start"
      :title="this.$t('title.online_purchase')"
    >
      <v-form>
        <v-container class="py-0">
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                :label="this.$t('label.name')"
                disabled
                :value="webshopPayment.customer_first_name"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                :label="this.$t('label.email')"
                disabled
                :value="webshopPayment.customer_email"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                :label="this.$t('label.date')"
                disabled
                :value="webshopPayment.created_at | datetime"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                :label="this.$t('label.product')"
                disabled
                :value="webshopPayment.product_name"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                :label="this.$t('label.status')"
                disabled
                :value="webshopPayment.external_payment_state | payment_state"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                :label="this.$t('label.amount')"
                disabled
                :value="(webshopPayment.amount / 100) | currency"
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
              v-if="webshopPayment.customer_license_plate"
            >
              <v-text-field
                :label="this.$t('label.license_plate')"
                disabled
                :value="webshopPayment.customer_license_plate"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <v-row class="pa-2" align="center">
        <v-col>
          <v-row v-if="isPaid" class="pa-5" align="center">
            <v-col cols="1" class="pa-1">
              <h2>{{ $t("title.qr_code") }}:</h2>
            </v-col>
            <v-col cols="3" class="text-center">
              <canvas id="delayed_delivery_identifier"></canvas>
              <h4 class="pb-4">
                {{ webshopPayment.delayed_delivery_identifier }}
              </h4>
              <v-btn color="primary" @click="downloadQRCode()">
                {{ this.$t("button.download") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </MaterialCard>
  </v-container>
</template>

<script lang="ts">
import Vue from "vue";
import { online_purchase_view } from "../../../../../mixins/online_purchase.js";
import MaterialCard from "../../../../../components/views/MaterialCard.vue";

export default Vue.extend({
  components: { MaterialCard },
  mixins: [online_purchase_view],
  mounted() {},
  computed: {
    isPaid() {
      return (
        this.webshopPayment &&
        this.webshopPayment.external_payment_state === "paid"
      );
    }
  },
  methods: {
    downloadQRCode() {
      let link = document.createElement("a");
      link.download = `${this.webshopPayment.delayed_delivery_identifier}.png`;
      link.href = document
        .getElementById("delayed_delivery_identifier")
        .toDataURL();
      link.click();
    }
  }
});
</script>
